import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
    selector: 'ObfuscatedTextField',
    templateUrl: './html-templates/obfuscated-text-field.component.html'
})
export class ObfuscatedTextField {
    @Input() text = ''
    @Input() maxlength: string
    @Input() fieldId: string
    @Output() onValueChange: EventEmitter<string> = new EventEmitter<string>()
    @Output() onBlur: EventEmitter<undefined> = new EventEmitter<undefined>()
    @Output() onFocus: EventEmitter<undefined> = new EventEmitter<undefined>()

    fieldType = 'password'

    handleBlur() {
         this.fieldType = 'password'
         this.onBlur.emit()
    }

    handleFocus() {
         this.fieldType = 'text'
         this.onFocus.emit()
    }
}
